export default __webpack_public_path__ + "static/media/weekly-tournament-ico.816cc8d0.svg";